import { combineReducers } from "redux";
import {
  MEMBER_LOGIN_TRIGGER,
  MEMBER_TOKEN_LOADED,
  MEMBER_LOGOUT_TRIGGER,
  MEMBER_AUTH_LOADED,
  MEMBER_TOKEN_PRELOAD,
  MEMBER_STATUS_UPDATE_RECEIVED
} from "WebsiteApp/modules/auth/AuthActions";
import _ from "lodash";

function token(state = null, action) {
  switch (action.type) {
    case MEMBER_TOKEN_PRELOAD:
      return action.payload;
    case MEMBER_LOGIN_TRIGGER:
      return action.payload.token;
    case MEMBER_TOKEN_LOADED:
      return action.payload;
    case MEMBER_LOGOUT_TRIGGER:
      return null;
  }
  return state;
}

function profile(state = null, action) {
  switch (action.type) {
    case MEMBER_AUTH_LOADED:
      return {
        ...action.payload.profile,
        jumioKycProcess: action.payload.jumioKycProcess
      };
    case MEMBER_LOGOUT_TRIGGER:
      return null;
    case MEMBER_STATUS_UPDATE_RECEIVED:
      let oldState = state ? { ...state } : null;
      if (oldState) {
        return {
          ...oldState,
          unreadNotifications: action.payload.unreadNotifications,
          kycLevel: _.get(action.payload, "kycLevel", oldState.kycLevel),
          spentToday: action.payload.spentToday,
          monthIncome: action.payload.monthIncome
        };
      }
  }
  return state;
}

export default combineReducers({
  token,
  profile
});



// WEBPACK FOOTER //
// ./src/modules/auth/AuthReducers.js